exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__Error__container__yg9gF {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 50em;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 100%;\n}\n\n.dmb-web__Error__errorText__7YTHE {\n  font-size: 1.2em;\n}\n", ""]);

// exports
exports.locals = {
	"container": "dmb-web__Error__container__yg9gF",
	"errorText": "dmb-web__Error__errorText__7YTHE"
};